import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgProgressModule } from 'ngx-progressbar';
import { AppLoaderComponent } from '../shared/components/app-loader.component';
import { ImgSrcDirective } from '../shared/directives/img-src.directive';
import { AppTranslationModule } from '../translations/app-translations.module';
import { AppBreadcrumbComponent } from './components/app-breadcrumb.component';
import { EmbedHTMLDirective } from './directives/embed-Html.directive';
import { NoDblClickDirective } from './directives/no-dbl-click.directive';
import { SpecialCharacterDirective } from './directives/restrict-special-characters.directive';
import { AuthorizationExtensionPipe } from './pipes/authorization-extension.pipe';
import { AuthorizationPipe } from './pipes/authorization.pipe';
import { CCPipe } from './pipes/cc-value-format.pipe';
import { CurrencyTransformPipe } from './pipes/currency-format.pipe';
import { DisplayNameFormatPipe } from './pipes/display-name-format.pipe';
import { DistributorIdFormatPipe } from './pipes/distributor-id-format.pipe';
import { FindErrorCodesPipe } from './pipes/errorFind.pipe';
import { GovIdMaskPipe } from './pipes/gov-id-mask.pipe';
import { GroupByPipe } from './pipes/group-by.pipe';
import { IdentificationTypePipe } from './pipes/identification-type.pipe';
import { MonthPipe } from './pipes/month.pipe';
import { NumberFormat } from './pipes/number-format.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { ReplaceLinks } from './pipes/replace-links.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { MinutesSecondPipe } from './pipes/seconds-minutes.pipe';
import { SingleImageFilterPipe } from './pipes/single-image.filter.pipe';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { TranslateKey } from './pipes/translate-key.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipie';
import { RemoveElementPipe } from './pipes/remove-element.pipe';
import { ArrayFilterPipe } from './pipes/array-filter.pipe';
import { IbanFormat } from './pipes/iban-format.pipe';
import { RoundFormat } from './pipes/number-rounded.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppTranslationModule,
    RouterModule,
    NgProgressModule,
    InfiniteScrollModule,
    AngularMultiSelectModule
  ],
  declarations: [
    OrderByPipe,
    SearchPipe,
    SafeHtmlPipe,
    GroupByPipe,
    SafeUrlPipe,
    SanitizeHtmlPipe,
    AuthorizationPipe,
    AuthorizationExtensionPipe,
    TranslateKey,
    FindErrorCodesPipe, AppBreadcrumbComponent,
    AppLoaderComponent,
    TitleCasePipe,
    NumberFormat,
    RoundFormat,
    MonthPipe,
    CurrencyTransformPipe,
    CCPipe,
    ImgSrcDirective,
    DistributorIdFormatPipe,
    // FloatLabelDirective,
    SingleImageFilterPipe,
    SpecialCharacterDirective,
    NoDblClickDirective,
    EmbedHTMLDirective,
    ReplaceLinks,
    DisplayNameFormatPipe,
    IdentificationTypePipe,
    GovIdMaskPipe,
    MinutesSecondPipe,
    EllipsisPipe,
    RemoveElementPipe,
    ArrayFilterPipe,
    IbanFormat
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppTranslationModule,
    RouterModule,
    NgProgressModule,
    OrderByPipe,
    SafeUrlPipe,
    SearchPipe,
    SafeHtmlPipe,
    AuthorizationPipe,
    AuthorizationExtensionPipe,
    FindErrorCodesPipe,
    TranslateKey,
    InfiniteScrollModule, AppBreadcrumbComponent,
    AppLoaderComponent,
    AngularMultiSelectModule,
    TitleCasePipe,
    NumberFormat,
    RoundFormat,
    MonthPipe,
    CurrencyTransformPipe,
    CCPipe,
    ImgSrcDirective,
    DistributorIdFormatPipe,
    SanitizeHtmlPipe,
    SingleImageFilterPipe,
    SpecialCharacterDirective,
    NoDblClickDirective,
    GroupByPipe,
    EmbedHTMLDirective,
    ReplaceLinks,
    DisplayNameFormatPipe,
    IdentificationTypePipe,
    GovIdMaskPipe,
    MinutesSecondPipe,
    EllipsisPipe,
    RemoveElementPipe,
    ArrayFilterPipe,
    IbanFormat
  ]
})
export class AppCommonModule { }



// WEBPACK FOOTER //
// ./src/app/common/app-common.module.ts